import { cellRenderer, TableText } from '@clari/iris-table';
import { SourceType } from '@groove/api/gateway/v1/actions';
import { ActionCellParams } from 'Modules/ActionsRewrite_2024/components/columnDefs/keysToColumnDefinitions';

const daySplit = ' - Day ';

/**
 * Splits the action title into two rows only if the action source is flow
 * and it can easily be split in 2 by the Day
 *
 * TODO: Do split in grooveEngine as per WFA-119
 */
const titleCellRenderer = cellRenderer((params: ActionCellParams) => {
  const { summary, source } = params?.data || {};
  // TODO: grab from person step
  const splitSummary = summary.split(daySplit);

  if (!shouldSplit(splitSummary, source))
    return {
      primaryContent: <TableText>{summary}</TableText>,
    };

  return {
    primaryContent: <TableText>{splitSummary[0]}</TableText>,
    secondaryContent: (
      <TableText>
        <span className="text-clari-blue/600">Day {splitSummary[1]}</span>
      </TableText>
    ),
  };
});

export default titleCellRenderer;

function shouldSplit(splitSummary: string[], source: SourceType) {
  return splitSummary.length === 2 && source === 'FLOW';
}
